module.exports = __webpack_public_path__ + "static/media/8.dd4e93b7.png";